import HeroSection from './components/HeroSection';
import FeatureShowcase from './components/FeatureShowcase';
import UseCasesSection from './components/UseCasesSection';
import ProjectsSection from './components/ProjectsSection';
import TechnologySection from './components/TechnologySection';
import ContactSection from './components/ContactSection';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-dark">
      <Navigation />
      <HeroSection />
      <FeatureShowcase />
      <UseCasesSection />
      <ProjectsSection />
      <TechnologySection />
      <ContactSection />
      <Footer />
    </div>
  );
}
